// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__JbRZj","fileBtn":"File_fileBtn__qCFy-","closeBtn":"File_closeBtn__2dnlG","fileSelected":"File_fileSelected__3qTwt","disabled":"File_disabled__3BOYw"};